import React from 'react';

function Tick(props: React.OptionHTMLAttributes<HTMLOptionElement>) {
  return <option {...props} />;
}

export default Tick;
